<template>
<div class="el-scrollbar__wrap wrap-white padding-20">
  <div class="el-scrollbar__view">
  <el-tabs v-model="activeName" >
    <el-tab-pane label="登录" name="first">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>单一登陆配置</h3>
        </div>
        <el-form size="small" ref="loginFormSetting" :model="loginFormSetting">
          <el-form-item>
             <el-checkbox true-label="0" false-label="1" v-model="loginFormSetting.multiAccountLogin">单一登录</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="loginFormSetting.singleLoginType">
              <el-radio :disabled="loginFormSetting.multiAccountLogin ==='1'" label="1">后登陆踢出先登录</el-radio>
              <el-radio :disabled="loginFormSetting.multiAccountLogin ==='1'" label="2">已登陆禁止再登陆</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item>
            <el-button size="small" type="primary" @click="doSubmit(loginFormSetting)">保存</el-button>
          </el-form-item>
        </el-form>
         
          
      </el-card>
    </el-tab-pane>
    <el-tab-pane label="外观" name="second">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>外观配置</h3>
        </div>
        <el-form size="small" label-width="150px" :model="themeFormSetting">
          <el-form-item label="产品标题">
            <el-input v-model="themeFormSetting.productName"></el-input>
          </el-form-item>
          <el-form-item label="产品logo">
            <image-select v-model="themeFormSetting.logo"></image-select>
          </el-form-item>
          <el-form-item label="默认布局">
              <el-select v-model="themeFormSetting.defaultLayout" placeholder="请选择"  style="width: 100%;">
                <el-option
                  v-for="item in layouts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="默认主题">
            <div class="tag-group" style="margin-top:7px">
              <el-tooltip effect="dark" :content="item.key" placement="top-start" v-for="(item, index) in colorList" :key="index">
                <el-tag :color="item.color" class="themeColorTag" @click="themeFormSetting.defaultTheme = item.color">
                  <i class="el-icon-check themeColorFont" v-if="item.color === themeFormSetting.defaultTheme"></i>
                </el-tag>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="首页地址">
              <el-input v-model="themeFormSetting.homeUrl"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="doSubmit(themeFormSetting)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-tab-pane>
    <el-tab-pane label="短信" name="third">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>阿里大鱼短信配置(<a href="https://dayu.aliyun.com" target="_blank">官网</a>)</h3>
        </div>
        <el-form size="small" label-width="150px" :model="smsFormSetting">
          <el-form-item label="accessKeyId" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="smsFormSetting.accessKeyId" placeholder="此处需要替换成开发者自己的AK(在阿里云访问控制台寻找)"></el-input>
          </el-form-item>
          <el-form-item label="accessKeySecret" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="smsFormSetting.accessKeySecret" placeholder="此处需要替换成开发者自己的AK(在阿里云访问控制台寻找)"></el-input>
          </el-form-item>
          <el-form-item label="短信签名" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="smsFormSetting.signature" placeholder="必填:短信签名-可在短信控制台中找到"></el-input>
          </el-form-item>
          <el-form-item label="短信模板" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="smsFormSetting.templateCode" placeholder="必填:短信模板编号-可在短信控制台中找到"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="doSubmit(smsFormSetting)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-tab-pane>
    <el-tab-pane label="邮箱" name="fourth">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>发件人账户</h3>
        </div>
         <el-form size="small" label-width="150px" :model="emailFormSetting">
          <el-form-item label="邮箱服务器地址" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="emailFormSetting.smtp" placeholder=" 邮件服务器的SMTP地址，默认为smtp.<发件人邮箱后缀>" style="width: 250px;"></el-input>
          </el-form-item>
          <el-form-item label="邮箱服务器端口" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="emailFormSetting.port" placeholder="邮件服务器的SMTP端口，默认25" style="width: 250px;"></el-input>
          </el-form-item>
          <el-form-item label="系统邮箱地址" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="emailFormSetting.mailName" placeholder="用户名，默认为发件人邮箱前缀" style="width: 250px;"></el-input>
          </el-form-item>
          <el-form-item label="系统邮箱密码" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="emailFormSetting.mailPassword" placeholder="密码（注意，某些邮箱需要为SMTP服务单独设置密码，详情查看相关帮助）" show-password style="width: 250px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="doSubmit(emailFormSetting)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>客户填写设计咨询绑定发送邮箱</h3>
        </div>
         <el-form size="small" label-width="150px" :model="emailFormSetting">
          <el-form-item label="绑定邮箱地址" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model="emailFormSetting.sendEmail" placeholder="请输入绑定邮箱地址" style="width: 250px;"></el-input>
          </el-form-item>
          <el-form-item label="抄送邮箱地址">
            <div class="cc-email-box">
              <el-tag v-for="(email, index) in ccEmailList" :key="index" closable type="info" class="cc-email-tag" @close="removeCcEmail(index)">{{ email }}</el-tag>
              <el-input
                v-if="ccInputVisible"
                ref="ccInput"
                v-model="ccInputValue"
                size="small"
                style="width: 220px;"
                placeholder="请输入抄送邮箱，回车确认"
                @keyup.enter.native="addCcEmail"
                @blur="addCcEmail"></el-input>
              <el-button v-else size="mini" type="primary" icon="el-icon-plus" circle class="cc-add-btn" @click="showCcInput"></el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="handleSaveEmail">保存</el-button>
          </el-form-item>
        </el-form>

      </el-card>
    </el-tab-pane>
    <el-tab-pane label="上传" name="upload">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>上传文件配置</h3>
        </div>
        <el-form size="small" ref="uploadSetting" :model="uploadSetting" >
          <el-form-item label="限制上传视频大小" prop="uploadVideoSize" :rules="[
                  {required: true, message:'必填项不能为空', trigger:'blur'}
                 ]">
            <el-input v-model.number="uploadSetting.uploadVideoSize" @input="handleInput" placeholder="请输入"  style="width: 250px;">
              <template slot="append">MB</template>
            </el-input>
          </el-form-item>
           <el-form-item>
            <el-button size="small" type="primary" @click="doSubmit(uploadSetting)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-tab-pane>
  </el-tabs>
  </div>
</div>
</template>
<script>
  import configService from '@/api/sys/configService'
  export default {
    data () {
      return {
        activeName: 'first',
        loginFormSetting: {
          id: '',
          multiAccountLogin: '1',
          singleLoginType: '1'
        },
        themeFormSetting: {
          id: '',
          defaultTheme: '#1890FF',
          productName: '',
          logo: '',
          defaultLayout: '',
          homeUrl: ''
        },
        smsFormSetting: {
          id: '',
          accessKeyId: '',
          accessKeySecret: '',
          signature: '',
          templateCode: ''
        },
        emailFormSetting: {
          id: '',
          smtp: '',
          port: '',
          mailName: '',
          mailPassword: '',
          sendEmail: '',
          sendCcEmail: ''
        },
        // 抄送邮箱列表（UI展示用）
        ccEmailList: [],
        ccInputVisible: false,
        ccInputValue: '',
        uploadSetting: {
          id: '',
          uploadVideoSize: 100
        },
        colorList: [
          {
            key: '拂晓蓝（默认）', color: '#1890FF'
          },
          {
            key: '薄暮', color: '#F5222D', label: '1'
          },
          {
            key: '火山', color: '#FA541C', label: '2'
          },
          {
            key: '日暮', color: '#FAAD14'
          },
          {
            key: '明青', color: '#13C2C2'
          },
          {
            key: '极光绿', color: '#52C41A'
          },
          {
            key: '极客蓝', color: '#2F54EB'
          },
          {
            key: '酱紫', color: '#722ED1'
          },
          {
            key: '天空蓝', color: '#3e8df7'
          },
          {
            key: '咖啡色', color: '#9a7b71'
          },
          {
            key: '深湖蓝', color: '#07b2d3'
          },
          {
            key: '原谅绿', color: '#0cc26c'
          },
          {
            key: '古铜灰', color: '#757575'
          },
          {
            key: '珊瑚紫', color: '#6779fa'
          },
          {
            key: '橙黄', color: '#eb6607'
          },
          {
            key: '粉红', color: '#f74584'
          },
          {
            key: '青紫', color: '#9463f7'
          },
          {
            key: '橄榄绿', color: '#16b2a3'
          }
        ],
        layouts: [
          {label: '横向菜单', value: 'top'},
          {label: '左侧菜单', value: 'left'}
        ]
      }
    },
    activated () {
      configService.queryById().then(({data}) => {
        this.loginFormSetting = this.recover(this.loginFormSetting, data)
        this.themeFormSetting = this.recover(this.themeFormSetting, data)
        this.smsFormSetting = this.recover(this.smsFormSetting, data)
        this.emailFormSetting = this.recover(this.emailFormSetting, data)
        // 将后端逗号分隔的抄送邮箱拆分为标签列表
        this.ccEmailList = (this.emailFormSetting.sendCcEmail || '').split(',').filter(item => item && item.trim())
        this.uploadSetting = this.recover(this.uploadSetting, data)
      })
    },
    methods: {
      handleInput (value) {
        // 1. 移除所有非数字字符（保留负号）
        let filtered = value.replace(/[^\d-]/g, '')
        // 2. 处理负号（只能出现在开头）
        if (filtered.includes('-')) {
          filtered = '-' + filtered.replace(/-/g, '')
        }
        // 3. 更新值（并防止出现空负号）
        this.uploadSetting.uploadVideoSize = filtered === '-' ? '' : filtered
      },
      handleAvatarSuccess (res, file) {
        this.themeFormSetting.logo = res.url
      },

      beforeAvatarUpload (file) {
        const isJPG = file.type.indexOf('image/') >= 0
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传LOGO只能是图片格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传LOGO大小不能超过 2MB!')
          return false
        }
        return true
      },
      doSubmit (form) {
        configService.save(form).then(({data}) => {
          this.$message.success(data.msg)
          localStorage.setItem('defaultLayout', data.config.defaultLayout)
          localStorage.setItem('defaultTheme', data.config.defaultTheme)
          localStorage.setItem('uploadVideoSize', data.config.uploadVideoSize)
          this.$events.$emit('updateTheme', data.config.defaultTheme)
          this.$store.commit('config/updateConfig', data.config)
        })
      },
      // 保存前校验：主邮箱必填 + 主邮箱与抄送邮箱去重 + 抄送邮箱内部去重
      handleSaveEmail () {
        const sendEmail = (this.emailFormSetting.sendEmail || '').trim()
        if (!sendEmail) {
          this.$message.error('请填写绑定邮箱地址')
          return
        }
        const ccList = this.ccEmailList
        if (ccList.includes(sendEmail)) {
          this.$message.error('抄送邮箱与绑定邮箱重复：' + sendEmail)
          return
        }
        const seen = {}
        for (const email of ccList) {
          if (seen[email]) {
            this.$message.error('抄送邮箱重复：' + email)
            return
          }
          seen[email] = true
        }
        this.doSubmit({sendEmail: sendEmail, sendCcEmail: ccList.join(',')})
      },
      // 显示抄送邮箱输入框
      showCcInput () {
        this.ccInputVisible = true
        this.$nextTick(() => {
          if (this.$refs.ccInput) {
            this.$refs.ccInput.focus()
          }
        })
      },
      // 添加抄送邮箱（回车/失焦确认）
      addCcEmail () {
        // 防止回车后 blur 再次触发导致重复添加
        if (!this.ccInputVisible) return
        this.ccInputVisible = false
        const email = this.ccInputValue.trim()
        this.ccInputValue = ''
        if (!email) return
        // if (!this.isValidEmail(email)) {
        //   this.$message.error('邮箱格式不正确')
        //   return
        // }
        if (this.ccEmailList.includes(email)) {
          this.$message.warning('该抄送邮箱已存在')
          return
        }
        this.ccEmailList.push(email)
      },
      // 删除抄送邮箱
      removeCcEmail (index) {
        this.ccEmailList.splice(index, 1)
      },
      // 邮箱格式校验
      isValidEmail (email) {
        return /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email)
      }
    }
  }
</script>
<style>
.themeColorTag{
  width:25px !important; 
  height:25px !important; 
}
 .themeColorTag.el-tag + .el-tag {
    margin-left: 5px;
    margin-bottom: 0px;
}
.themeColorFont{
  position: absolute;
  color: #fff;
  margin-top: 3px;
  margin-left: -6px;
  font-weight: bold;
  font-size: 16px;
}
.w250px {
  width: 250px;
}
.cc-email-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.cc-email-tag {
  margin-right: 0;
}
.cc-add-btn {
  padding: 4px;
}
</style>